import { ColumnSetting } from '../../../../_foundation/models/grid.models';

export const vesselOvertimeColumns: ColumnSetting[] = [
  {
    field: 'name',
    title: 'Name',
    filter: 'text'
  },
  {
    field: 'function',
    title: 'Function',
    filter: 'text'
  },
  {
    field: 'hours',
    title: 'Hours',
    filter: 'text'
  },
  {
    field: 'description',
    title: 'Description',
    filter: 'text'
  },
  {
    field: 'requestedBy',
    title: 'Cadeler/Client Request',
    filter: 'text'
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 150
  }
];



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/vessel-crew/vessel-crew-edit-component/vessel-crew-overtime-list.config.ts